export const ADD_ACCOUNT = 'account/add';
export const SELECT_ACCOUNT = 'account/select';
export const CHANGE_CREATE_ACCOUNT_STATUS = 'account/createAccount';
export const EDIT_ACCOUNT = 'account/editAccount';
export const EDIT_INTRO_ORDER = 'trade/EDIT_INTRO_ORDER';
export const EDIT_INTRO_USER = 'trade/EDIT_INTRO_USER';
export const CHANGE_CONFIRMSTATUS = 'balance/CHANGE_CONFIRMSTATUS';
export const LOGOUT = 'account/LOGOUT';
export const LOGIN = 'account/LOGIN';
export const SET_ACCOUNT_LIST = 'account/SET_ACCOUNT_LIST';
export const CHANGE_INVITER_NOT_EXIST = 'account/CHANGE_INVITER_NOT_EXIST';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js